<template>
  <b-form
    class="confirm-form input-password-form custom-input-form preview"
    aria-live="assertive"
    @submit.stop.prevent="onSubmit"
  >
    <div class="password">
      <b-form-group
        :label="$t('resetPwd.confirm.password')"
        label-for="user-register-name"
        class="text-muted custom-size-16"
      >
        <b-input-group>
          <b-form-input
            id="confirm-pwd"
            v-model.trim="form.password"
            name="confirm-pwd"
            :type="passwordFieldType1"
            :state="validateState('password')"
            aria-describedby="input-password-feedback"
            :placeholder="$t('resetPwd.confirm.password')"
            class="custom-form-input custom-form-input-class text-muted"
            @blur="onBlur('password')"
          ></b-form-input>
          <b-input-group-append>
            <b-button class="preview-icon d-flex align-items-center" @click="showPwd('password')">
              <svg-icon
                v-show="!showPassword1"
                class="fill-icon show-icon"
                name="close-eye"
                size="20"
              ></svg-icon>
              <svg-icon
                v-show="showPassword1"
                class="fill-icon show-icon"
                name="open-eye"
                size="20"
              ></svg-icon>
            </b-button>
          </b-input-group-append>
          <b-form-invalid-feedback id="input-email-feedback">
            {{ $t('resetPwd.confirm.error.textError1') }}
            {{ $v.form.password.$params.minLength.min }}
            {{ $t('resetPwd.confirm.error.textError2') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
    </div>

    <div class="pwd my-4">
      <b-form-group
        :label="$t('resetPwd.confirm.confirmPassword')"
        label-for="user-register-name"
        class="text-muted custom-size-16"
      >
        <b-input-group>
          <b-form-input
            id="confirm-repeat-pwd"
            v-model.trim="form.repeatPassword"
            :type="passwordFieldType2"
            name="confirm-repeat-pwd"
            :state="validateState('repeatPassword')"
            aria-describedby="input-password-confirm-feedback"
            :placeholder="$t('resetPwd.confirm.confirmPassword')"
            class="custom-form-input custom-form-input-class text-muted"
            @blur="onBlur('repeatPassword')"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              class="preview-icon d-flex align-items-center"
              @click="showPwd('repeatPassword')"
            >
              <svg-icon
                v-show="!showPassword2"
                class="fill-icon show-icon"
                name="close-eye"
                size="20"
              ></svg-icon>
              <svg-icon
                v-show="showPassword2"
                class="fill-icon show-icon"
                name="open-eye"
                size="20"
              ></svg-icon>
            </b-button>
          </b-input-group-append>
          <b-form-invalid-feedback id="input-email-feedback">
            {{ $t('message.error.passwordsMatch') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
    </div>

    <div class="margin-top-30">
      <b-button
        type="submit"
        class="btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
        :disabled="processing"
        variant="primary"
      >
        <p v-if="!processing">{{ $t('resetPwd.confirm.buttonText') }}</p>
        <div v-if="processing">
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
        </div>
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators';
import { i18n } from '@/plugins/i18n';

export default {
  name: 'ConfirmPasswordForm',
  data() {
    return {
      showPassword1: false,
      passwordFieldType1: 'password',
      showPassword2: false,
      passwordFieldType2: 'password',
      lang: {},
      form: {
        password: '',
        repeatPassword: '',
      },
      valid: false,
    };
  },
  computed: {
    processing() {
      return this.$store.getters.getProcessing;
    },
    currentLang() {
      return this.$route.params.lang.toLowerCase();
    },
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
      },
      repeatPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
  mounted() {
    this.changeLocale();
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onBlur(name) {
      this.$v.form[name].$touch();
    },
    showPwd(name) {
      if (name === 'password') {
        this.showPassword1 = !this.showPassword1;
        this.passwordFieldType1 = this.passwordFieldType1 === 'password' ? 'text' : 'password';
      }

      if (name === 'repeatPassword') {
        this.showPassword2 = !this.showPassword2;
        this.passwordFieldType2 = this.passwordFieldType2 === 'password' ? 'text' : 'password';
      }
    },
    changeLocale() {
      i18n.locale = this.currentLang;
      localStorage.setItem('userLocale', this.currentLang);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      const hash = this.$route.params.hash;

      this.$store.commit('SET_PROCESSING', true);
      this.$emit('submit', this.form.password, hash);
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-form :deep {
  .custom-size-16 label {
    font-size: 16px;
  }
  .custom-form-input.custom-form-input-class {
    border-color: white !important;
  }
}
</style>
